const cardFooterStyle = {
  cardFooter: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "transparent",
    padding: "16px",
    justifyContent: "space-between !important" ,
  },
};

export default cardFooterStyle;
